<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">添加成员</span>
    </div>
    <div class="box">
      <div class= "box_1" v-if="!newContact">
        <div class="main">
        <div class="outer_3">
          <div class="outer_attr" @click="autofocus('search_name')">
            <div class="group">
              <div class="attr_name">姓名</div>
              <input class="input_text" v-model.trim="nameQuery" id="search_name" type="text" placeholder="请输入姓名">
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr" @click="autofocus('search_mobile')">
            <div class="group">
              <div class="attr_name">手机号</div>
              <input class="input_text" v-model.trim="mobileQuery" id="search_mobile" type="text" placeholder="请输入手机号">
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
        </div>
      </div>
        <div class="ft research-background-color" @click="searchContact">
        <span class="addMember">搜索联系人</span>
      </div>
      </div>
      <div class="box_2">
        <div class="main" v-if="contactDetail && contactDetail.customerName">
        <div class="outer_3" >
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">姓名</span>
              <span class="attr">{{contactDetail.customerName}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">手机</span>
              <span class="attr">{{contactDetail.mobile}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">邮箱</span>
              <span class="attr">{{contactDetail.email}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">单位</span>
              <span class="attr">{{contactDetail.enterpriseName}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
<!--          <div class="outer_attr" v-if="contactDetail.enterpriseName.includes('医院') && contactDetail.secondLevelEnterpriseName">-->
<!--            <div class="group">-->
<!--              <span class="attr_name">科室</span>-->
<!--              <span class="attr">{{contactDetail.secondLevelEnterpriseName}}</span>-->
<!--            </div>-->
<!--            <div class="container"><div class="empty" /></div>-->
<!--          </div>-->
        </div>
      </div>
      </div>
      <div class="box_2">
        <div class="main" v-if="contactDetail && contactDetail.customerName">
          <div class="outer_3" >
<!--            <div class="outer_attr">-->
<!--              <div class="group">-->
<!--                <span class="attr_name">开启审批</span>-->
<!--                <span class="attr" ><label class="label-switch">-->
<!--                          <input id ="express" type="checkbox" v-model="startChooseBox" @change="changeapprove">-->
<!--                          <div class="checkbox" style="background-color: #5878fa;"></div>-->
<!--                        </label></span>-->
<!--              </div>-->
<!--              <div class="container"><div class="empty" /></div>-->
<!--            </div>-->
            <div class="outer_attr">
              <div class="group">
                <span class="attr_name">审批原则</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(0)">
                  <span class="attr" v-if="approve.approveType === undefined" style="color: #FE654D;">请设置审批原则</span>
                  <span class="attr" v-if="approve.approveType === approveTypeNone" style="color: #60d837;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <span class="attr" v-if="approve.approveType === approveTypeAll" style="color: #ff9400;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <span class="attr" v-if="approve.approveType === approveTypeThreshold" style="color: #ff9400;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>

            <div class="outer_attr" v-if="approve.approveType === approveTypeThreshold">
              <div class="group">
                <span class="attr_name">单笔订单限额</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(1)">
                  <span class="attr" v-if="approve.approveThreshold ===undefined" style="color: #FE654D;">请设置审批限额</span>
                  <span class="attr unlimitedAmount" v-else-if="approve.approveThreshold ===''">无限额</span>
                  <span v-else class="price">¥{{approve.approveThreshold}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>
            <div class="outer_attr" v-if="approve.approveType === approveTypeThreshold">
              <div class="group">
                <span class="attr_name">单月累积限额</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(2)">
                  <span class="attr" v-if=" approve.monthlyLimit === undefined" style="color: #FE654D;">请设置审批限额</span>
                  <span class="attr unlimitedAmount" v-else-if="approve.monthlyLimit ===''" >无限额</span>
                  <span v-else class="price">¥{{approve.monthlyLimit}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>
          </div>

        </div>
<!--        <span class="submain" v-if="approve.approveType && approve.approveType === approveTypeNone">-->
<!--       启用此选项后，该课题组成员在商城下单后需要审批人进行审批。-->
<!--      </span>-->
<!--        <span class="submain" v-else-if="approve.approveType && approve.approveType === approveTypeAll">-->
<!--      该课题组成员所有的订单均需要审批人进行审批。-->
<!--      </span>-->
<!--        <span class="submain" v-else-if="approve.approveType && approve.approveType === approveTypeThreshold">-->
<!--      启用此选项后，该课题组成员在商城下单后需要审批人进行审批。-->
<!--      </span>-->
        <div class="ft research-background-color" v-if="contactDetail && contactDetail.customerName" @click="addMember">
          <span class="addMember">添加</span>
        </div>
      </div>
    </div>
    <ChooseApproveType1 v-if="showChooseApproveType " @updateMemberApproveType="saveApproveType"  :setApproveType="setallApproveType"  @toggleShow="toggleShowChooseBox(0)" />
    <ChooseApproveType2 v-if="showChooSinglestrokeApproveType " @updateMemberApproveType="saveApproveType" :setApproveType="setSinglestrokeApproveType"  @toggleShow="toggleShowChooseBox(1)" />
    <ChooseApproveType2 v-if="showChooSinglemouthApproveType " @updateMemberApproveType="saveApproveType"  :setApproveType="setmouthApproveType"  @toggleShow="toggleShowChooseBox(2)" />
    <ResearchGroupRemindBox :remindParams="remindParams" @confirm="registerContact" v-if="showResearchGroupRemindBox" @toggleShow="toggleResearchGroupRemindBox"/>
  </div>
</template>
<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import $ from 'jquery'
// eslint-disable-next-line no-unused-vars
import ChooseApproveType1 from './../researchGroupComponents/ChooseApproveType1'
import ChooseApproveType2 from './../researchGroupComponents/ChooseApproveType2'
import ResearchGroupRemindBox from './../researchGroupComponents/ResearchGroupRemindBox'
import EMKT from '../../../../emkt'
export default {
  data () {
    return {
      researchGroupApproveTypeDictionary: EMKT.researchGroupApproveTypeDictionary,
      approveTypeThreshold: EMKT.CONSTANT_APPROVETYPE_THRESHOLD,
      approveTypeNone: EMKT.CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: EMKT.CONSTANT_APPROVETYPE_ALL,
      mobileQuery: '',
      nameQuery: '',
      contactDetail: {},
      showChooseApproveType: false,
      showResearchGroupRemindBox: false,
      approve: {},
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      newContact: this.$route.query.newContact,
      // startChooseBox: true,
      showChooSinglestrokeApproveType: false,
      showChooSinglemouthApproveType: false,
      setSinglestrokeApproveType: EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: EMKT.CONSTANT_ALL_APPROVETYPE,
      isWapp: EMKT.isWapp
    }
  },
  computed: {
    ...mapState([
      'researchGroupMemberMap', 'sessionInfo'
    ]),
    ...mapGetters([
      'displayChosenResearchGroup', 'customerNo', 'hasLogin', 'researchGroupCharacter'
    ])
  },
  mounted () {
    console.log('newContact', this.newContact)
    if (this.newContact) this.contactDetail = this.$route.query.newContact
  },
  components: {
    ChooseApproveType1, ResearchGroupRemindBox, ChooseApproveType2
  },
  methods: {
    ...mapMutations([
      'UPDATE_RESEARCHGROUP_MEMBER_MAP'
    ]),
    goBack () {
      this.$router.go(-1)
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    // changeapprove () {
    //   this.startChooseBox === false ? this.approve.approveType = this.approveTypeNone : this.approve.approveType = undefined
    //   console.log(this.approveType)
    // },
    toggleShowChooseBox (data) {
      console.log(data)
      switch (data) {
        case 0: this.showChooseApproveType = !this.showChooseApproveType
          break
        case 2: this.showChooSinglemouthApproveType = !this.showChooSinglemouthApproveType
          break
        case 1: this.showChooSinglestrokeApproveType = !this.showChooSinglestrokeApproveType
      }
    },
    saveApproveType (approve, setApproveType) {
      this.approve.approveType === approve.approveType
      setApproveType === this.setallApproveType ? this.approve = approve : (setApproveType === this.setSinglestrokeApproveType ? this.approve.approveThreshold = approve.approveThreshold : this.approve.monthlyLimit = approve.monthlyLimit)
      console.log('approve', this.approve)
    },
    validatemobile (mobile) {
      if (mobile.length === 0) {
        $.toast('手机号码不能为空')
        return false
      }
      let myreg = /^1[3-9]{1}[0-9]{9}$/
      if (mobile.length !== 11 || !myreg.test(mobile)) {
        $.toast('请输入有效的手机号码')
        return false
      }
      return true
    },
    searchContact () {
      console.log('Query', this.mobileQuery, this.nameQuery)
      this.contactDetail = {}
      if (!this.nameQuery || !this.validatemobile(this.mobileQuery)) {
        $.toast('请输入姓名和正确的手机号')
        return
      }
      // 根据联系人手机号、姓名、一级单位编号搜索联系人个人信息
      if (this.customerNo) {
        const queryParam = {}
        queryParam.customerName = this.nameQuery
        queryParam.mobile = this.mobileQuery
        // queryParam.enterpriseNo = EMKT.testEnterpriseNo // 测试用复旦大学附属中山医院.  00000267
        queryParam.enterpriseNo = this.sessionInfo.customerInfo.enterpriseNo
        this.$weui.loading('查询中')
        this.gcapi('searchContact', queryParam).then(response => {
          this.$weui.loading().hide()
          console.log('rsponse', response)
          if (response && response.body.code === 1) {
            this.remindParams.firstline = '该联系人未注册'
            this.remindParams.secondline = '是否注册新联系人？'
            this.remindParams.singleOrDouble = 2
            this.toggleResearchGroupRemindBox()
            return
            // $.toast('无此联系人，请新建联系人')
            // return this.$router.push({name: 'RegisterContact', query: {defaultIndex: this.defaultIndex}})
          }
          if (response && response.body.result) {
            this.contactDetail = response.body.result
          } else {
            this.remindParams.firstline = '该联系人与您不在同一单位'
            this.remindParams.secondline = '请联系业务员添加'
            this.remindParams.singleOrDouble = 1
            this.toggleResearchGroupRemindBox()
            // $.alert('未查到同一单位的联系人信息，请联系业务员添加')
          }
        }).catch(e => {
          console.log('e', e)
        })
      }
    },
    convertContactToNewMember (contact) {
      // debugger
      const newMember = {}
      // 来自data
      newMember.researchGroupName = this.displayChosenResearchGroup.researchGroupName
      newMember.researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
      newMember.approveType = this.approve.approveType
      if (this.approve.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD) {
        newMember.approveThreshold = this.approve.approveThreshold === '' ? null : this.approve.approveThreshold
        newMember.monthlyLimit = this.approve.monthlyLimit === '' ? null : this.approve.monthlyLimit
      } else {
        newMember.approveThreshold = null
        newMember.monthlyLimit = null
      }
      // 来自联系人信息
      newMember.memberGuid = contact.customerGuid // 成员GUID
      newMember.memberNo = contact.customerNo // 成员编号（客户编号）
      newMember.memberName = contact.customerName
      newMember.email = contact.email
      newMember.mobile = contact.mobile
      newMember.firstLevelEnterpriseNo = contact.enterpriseNo
      newMember.firstLevelEnterpriseName = contact.enterpriseName
      newMember.secondLevelEnterpriseNo = contact.secondLevelEnterpriseNo
      newMember.secondLevelEnterpriseName = contact.secondLevelEnterpriseName
      // 创建时间、创建人
      newMember.createDT = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()
      newMember.creator = this.sessionInfo.customerInfo.customerNo + '/' + this.sessionInfo.customerInfo.customerName // 创建人 员工编号/姓名
      newMember.startDT = newMember.createDT
      newMember.enable = true
      return newMember
    },
    addMember () {
      console.log(this.hasLogin)
      if (!this.hasLogin) {
        $.toast('请先去登录')
        this.$router.push({name: 'login'})
        return
      }
      if (this.newMemberAlreadyExist(this.contactDetail)) {
        this.remindParams.firstline = '此人已加入课题组'
        this.remindParams.secondline = '无需添加'
        this.remindParams.singleOrDouble = 1
        this.toggleResearchGroupRemindBox()
        // $.alert('此人已加入课题组，无需添加')
        return
      }
      if (this.approve.approveType === undefined) {
        $.toast('请设置审批原则')
        return false
      }
      const newMember = this.convertContactToNewMember(this.contactDetail)
      console.log('newMember', newMember)
      const self = this
      this.$weui.loading('保存中')
      setTimeout(function () {
        self.gcapi('saveOrUpdateResearchGroupMember', newMember).then(res => {
          self.$weui.loading().hide()
          if (res && res.body.result) {
            const newMemberMap = {...self.researchGroupMemberMap}
            newMemberMap[newMember.researchGroupNo].push(res.body.result)
            self.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap)
            self.$weui.toast('添加成功')
            self.$router.replace({name: 'ResearchMemberManagement'})
          } else {
            self.$weui.toast('添加失败，请重试')
          }
        })
      }, 3000)
    },
    newMemberAlreadyExist (contact) {
      const members = this.researchGroupMemberMap[this.displayChosenResearchGroup.researchGroupNo]
      if (!members) {
        return false
      }
      for (let member of members) {
        if (member.memberNo === contact.customerNo) {  // 需改为验证新添加成员的编号是否已经存在
          return true
        }
      }
      return false
    },
    toggleResearchGroupRemindBox () {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox
    },
    registerContact () {
      this.$router.push({name: 'RegisterContact', query: {name: this.nameQuery, mobile: this.mobileQuery}})
    },
    autofocus (id) {
      $('#' + id).focus()
    }
  }
}
</script>
<style scoped>
html, body {
  height: 100%;
}

.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}

.box {
   /*display: flex;*/
   position: relative;
   align-items: center;
   /*flex-direction: column;*/
   background-color: #efeef3;
   width: 100vw;
   height: 100vh;
   top: 14.93vw;
   left: 0;
 }
.box_1 {
  display: flex;
  /*position: absolute;*/
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  /*height: 100vh;*/
  /*top: 0;*/
  /*margin: 6.67vw 0;*/
}
.box_2 {
  display: flex;
  /*position: absolute;*/
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  /*height: 100vh;*/
  /*top: 57vw;*/
  margin-bottom: 6.67vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}
.main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 6.67vw 0;
  width: 99.73vw;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
}
.attr {
  opacity: 1;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
}
.outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}
.wrap_approvetype {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  width: 40vw;
  height: 5.33vw;
}
.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 86.4vw;
}

.liveiconput {
  margin-left: 1vw;
  width: 4.5vw;
  height: 4.5vw;
}

.input_text {
  opacity: 1;
  text-align: left;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
  width: 58vw;
  outline: none;
  border: none;
  padding: 0;
}

.ft {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  /* margin-top: 6.67vw; */
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 86.67vw;
  height: 13.33vw;
}

.addMember {
  opacity: 1;
  margin-top: 1.07vw;
  max-width: 47.2vw;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

input::-webkit-input-placeholder {
  text-align: start;
  color: #D5D5D5;
}
.submain {
  overflow: hidden;
  text-align: justify;
  text-overflow: ellipsis;
  line-height: 4vw;
  color: #929292;
  font-size: 1.6vw;
  font-weight: 400;
  margin-top: -1rem;
  margin-bottom: 1rem;
}
.unlimitedAmount {
  opacity: 1;
  color: #60d837;
  font-size: 1.87vw;
  font-weight: 400;
}
  .price{
    color: #ff9400;
    font-size: 3.87vw;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// AddResearchMember.vue?524655aa